function addCustomEventListener(selector, event, handler) {
    let rootElement = document.querySelector('body');
    //since the root element is set to be body for our current dealings
    rootElement.addEventListener(event, function (evt) {
            var targetElement = evt.target;
            while (targetElement != null) {
                if (targetElement.matches(selector)) {
                    handler(evt);
                    return;
                }
                targetElement = targetElement.parentElement;
            }
        },
        true
    );
}

function encodeString(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
}

function fireGTMEvent(event)
{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': event
    });
}

function hideOnClickOutside(element) {
    // console.log(element);
    const outsideClickListener = event => {
        if (event.target.closest(event.target) === null) { // or use: 
            alert('a');
            element.remove();
            removeClickListener();
        }
    }

    const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener)
    }

    document.addEventListener('click', outsideClickListener)
}

function hasClass(ele,cls) {
    return ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
}

$(document).ready(function() {
    (function($) {
        $.fn.buttonLoadingState = function(action) {
            if (action === 'loading' && this.data('loading-text')) {
                this.data('original-text', this.html()).html(this.data('loading-text')).prop('disabled', true);
            }
            if (action === 'reset' && this.data('original-text')) {
                this.html(this.data('original-text')).prop('disabled', false);
            }
        };
    }(jQuery));
});

function urlParamExists(param, value = null)
{
    var urlParams = new URLSearchParams(window.location.search);
    var search = urlParams.get(param);
    
    if(search) {
        return true;
    }

    if (value != null) {
        if(search == value) {
            return true;
        }
    }
    
    return false;
}

function copyToClipboard(elementId) {
    var aux = document.createElement("input");
    var target = document.getElementById(elementId);
    var element_type = target.tagName.toLowerCase();
    let value = null;
    switch (element_type) {
        case 'input':
            value = target.value;
        break;
        default:
            value = target.innerHTML;
        break;
    }        
    aux.setAttribute("value", value);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    document.body.removeChild(aux);
}

function replaceAll(str,mapObj){
    var re = new RegExp(Object.keys(mapObj).join("|"),"gi");

    return str.replace(re, function(matched){
        return mapObj[matched.toLowerCase()];
    });
}

// Set a Cookie
function setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

function readCookie(name) {
    name += '=';
    for (var ca = document.cookie.split(/;\s*/), i = ca.length - 1; i >= 0; i--)
        if (!ca[i].indexOf(name))
            return ca[i].replace(name, '');
}

function nextChar(c) {
    return String.fromCharCode(c.charCodeAt(0) + 1);
}

function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

var support = (function () {
	if (!window.DOMParser) return false;
	var parser = new DOMParser();
	try {
		parser.parseFromString('x', 'text/html');
	} catch(err) {
		return false;
	}
	return true;
})();

var stringToHTML = function (str) {

	// If DOMParser is supported, use it
	if (support) {
		var parser = new DOMParser();
		var doc = parser.parseFromString(str, 'text/html');
		return doc.body;
	}

	// Otherwise, fallback to old-school method
	var dom = document.createElement('div');
	dom.innerHTML = str;
	return dom;

};

function getInnerWidth(elem) {
    return parseFloat(window.getComputedStyle(elem).width);
}

function nl2br(str, is_xhtml = true) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />'   : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag   + '$2');
}

function isValidHttpUrl(string) {
    let url;

    string = prependHttp(string);

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
}

function isValidUrl(string) {
    try {
        new URL(string);
        return true;
    } catch (err) {
        return false;
    }
}

function extractHostname(url) {
    var hostname;
    //find & remove protocol (http, ftp, etc.) and get hostname
  
    if (url.indexOf("//") > -1) {
      hostname = url.split('/')[2];
    } else {
      hostname = url.split('/')[0];
    }
  
    //find & remove port number
    hostname = hostname.split(':')[0];
    //find & remove "?"
    hostname = hostname.split('?')[0];
  
    return hostname;
  }
  
  
function appendFaviconToTile(tile)
{
    let url = null;

    if (tile.hasAttribute('data-url')) {
        url = tile.dataset.url;
    }

    if (tile.hasAttribute('data-root-domain')) {
        url = tile.dataset.rootDomain;
    }

    const link_el = tile.querySelector('a.tool__visit');
    if (link_el !== 'undefined' && link_el !== null) {
        url = link_el.href;
    }

    if (url == 'undefined' || url == null || typeof url == undefined) { return; }

    let domain = url;
    if (url.indexOf('google.com') !== -1) {
    } else {
        const parsed = psl.parse(extractHostname(url));
        domain = prependHttp(parsed.domain);
    }
    
    const container_favicon = tile.querySelector('.tool__favicon');
    const favicon_image = container_favicon.querySelector('img');

    if (favicon_image !== null && favicon_image !== 'undefined') { return; }

    let faviconUrl = `https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${domain}&size=256`;
    let img = new Image();
    img.src = faviconUrl;
    img.onload = function() {
        container_favicon.appendChild(img);
    };
    img.onerror = function() {
        console.error('Error loading favicon');
    };
}

// From sindresorhus/prepend-http
function prependHttp(url, {https = true} = {}) {
	if (typeof url !== 'string') {
        return;
		throw new TypeError(`Expected \`url\` to be of type \`string\`, got \`${typeof url}\``);
	}

	url = url.trim();

	if (/^\.*\/|^(?!localhost)\w+?:/.test(url)) {
		return url;
	}

	return url.replace(/^(?!(?:\w+?:)?\/\/)/, https ? 'https://' : 'http://');
}

function loadAiSuggestions(amount = 2)
{
    // @todo avoid multiple concurrent requests to openai. disable accept/deny buttons?
    const csrf_name = document.getElementsByName('csrf_name')[0].value;
    const csrf_value = document.getElementsByName('csrf_value')[0].value;

    const tool_group = document.getElementById('tool_group__active');
    const btn_new = document.getElementById('btn_new_menu');

    const rackoot_data = document.getElementById('rackoot_data');

    const loader = document.getElementById('tool__ai_suggestions_loading');

    let ignore = [];
    const active_suggestions = document.querySelectorAll('.tool.is_suggested');
    if (active_suggestions.length > 0) {
        for (let i = 0; i < active_suggestions.length; i++) {
            ignore.push(active_suggestions[i].dataset.toolUuid);
        }
    }

    var data = new FormData();
    data.append('csrf_name', csrf_name);
    data.append('csrf_value', csrf_value);
    data.append('rackoot_uuid', rackoot_data.dataset.uuid);
    data.append('amount', amount);
    data.append('ignore', ignore);

    loader.classList.remove('d-none');

    axios.post(GlobalRoutes.ai.suggestions.tiles.get, data)
        .then(function (response) {
            const suggestions = response.data.suggestions;
            if (suggestions !== null && suggestions !== 'undefined') {
                let suggestion_template = document.getElementById('template_render_suggestion').innerHTML;
                
                for (var i = 0; i < suggestions.length; i++){
                    let suggestion = suggestions[i];
                    let newSuggestion = replaceAll(suggestion_template, {
                        '{name}': suggestion.name,
                        '{icon}': '',
                        '{initials}': '',
                        "{bg}": '#ffffff',
                        "{id}": suggestion.id,
                        "{color}": '#000000',
                        "{url}": suggestion.url,
                        "{description}": suggestion.description,
                        "{reason}": suggestion.reason,
                        "{uuid}": rackoot_data.dataset.uuid,
                    });
                    btn_new.insertAdjacentHTML('beforeBegin', newSuggestion);
                    let newItem = document.getElementById(suggestion.id);
                    // console.log(newItem);
                    appendFaviconToTile(newItem);
                }
            }

            loader.classList.add('d-none');
        })
        .catch(function (error) {
            new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
        });
}

function cleanHexColor(color)
{
    const test = /^#([0-9A-F]{3}){1,2}$/i.test(color);
    if (!test) {
        return '#5372f0';
    }

    return color;
}

function genRandonString(length) {
    var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
    var charLength = chars.length;
    var result = '';
    for ( var i = 0; i < length; i++ ) {
       result += chars.charAt(Math.floor(Math.random() * charLength));
    }
    return result;
}

function strip(html){
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
}

function module_enabled(name)
{
    const enabled = (InstanceModules[name] === "true");
    //console.log(name, enabled);
    return enabled;
}

function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

